import React from 'react';

export const CaloriesCalculator = () => {
    return (
        <div>
            Calories Calculator Page
        </div>
    );
};